// ssn format: XXX-XX-XXXX
const formatSSN = (value) => {
  let ssn = value.replace(/[^0-9]+/g, "");  // ignore non-numeric characters
  if (ssn.length >= 5) {
    return ssn.slice(0, 3) + "-" + ssn.slice(3, 5) + "-" + ssn.slice(5, 9);
  } else if (ssn.length >= 3) {
    return ssn.slice(0, 3) + "-" + ssn.slice(3, 5)
  } else {
    return ssn.slice(0, 3)
  }
}

// ein format: XX-XXXXXXX
const formatEIN = (value) => {
  let ein = value.replace(/[^0-9]+/g, "");  // ignore non-numeric characters
  if (ein.length >= 2) {
    return ein.slice(0, 2) + "-" + ein.slice(2, 9)
  } else {
    return ein.slice(0, 2)
  }
}

// date format: YYYY-MM-DD
const formatDate = (value) => {
  let date = value.replace(/[^0-9]+/g, ""); // ignore non-numeric characters
  if (date.length >= 6) {
    return date.slice(0, 4) + "-" + date.slice(4, 6) + "-" + date.slice(6, 8);
  } else if (date.length >= 4) {
    return date.slice(0, 4) + "-" + date.slice(4, 6)
  } else {
    return date.slice(0, 4)
  }
}

export {
  formatSSN,
  formatEIN,
  formatDate,
}
